<template>
    <div>
      <div class="teams">
        <!-- <teams v-for="item in teamList" :key="item.id" :item="item"></teams> -->
      </div>
    </div>
</template>

<script>
// import teams from './TeamList'

export default {
  // components: { teams },
  props: {
    match: {
      typeof: Object,
      default:() => {}
    },
    result: {
      typeof: Object,
      default:() => {}
    },
    data1: {
      typeof: Object,
      default: () => {}
    },
    newsList: {
      typeof: Array,
      default: () => []
    },
    videoList: {
      typeof: Array,
      default: () => []
    },
    teamList: {
      typeof: Array,
      default: () => []
    },
    matchList: {
      typeof: Array,
      default: () => []
    }
  },
  data() {
      return {

      };
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">

</style>
